import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap } from 'rxjs/operators';
import { ParameterEntryCyclesService } from '../../_generated';
import * as ErrorActions from '../actions/error.actions';
import { ParameterEntryCyclesAction } from '../actionstypes/parameter-entry-cycles/parameter-entry-cycles.actiontype';
import * as SitesAction from '../actionstypes/sites/sites.actiontype';

@Injectable()
export class ParameterEntryCyclesEffect {
  private readonly actions$ = inject(Actions);
  private readonly parameterEntryCyclesService = inject(ParameterEntryCyclesService);

  updateEntryCycleStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParameterEntryCyclesAction.get),
      exhaustMap((action) => {
        return this.parameterEntryCyclesService
          .parameterEntryCyclesControllerFind(
            action.siteId,
            action.shopId,
            action.toolId,
            action.emissionPointId,
            action.parameterId,
            action.entryCycleId,
            action.parameterType,
          )
          .pipe(
            map((parameterEntryCycle) => ParameterEntryCyclesAction.getSuccess({ payload: parameterEntryCycle })),
            catchError((error) =>
              of(ParameterEntryCyclesAction.error({ error: error.message }), ErrorActions.displayGlobalError({ error: error as Error })),
            ),
          );
      }),
    ),
  );

  successRequestParameterEntryCycles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParameterEntryCyclesAction.getSuccess),
      mergeMap((action) =>
        of(
          new SitesAction.UpdateParameterStatus({
            siteId: action.payload.idSite,
            shopId: action.payload.idShop,
            toolId: action.payload.idTool,
            emissionPointId: action.payload.idEmissionPoint,
            parameterId: action.payload.idParameter,
            status: action.payload.status,
          }),
          new SitesAction.Load(),
        ),
      ),
    ),
  );
}
